export default "/img/TW.9442c797b00c0bf4c4243c8435fedf1c.png";